module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.$route.name === 'dashboard-sales') ? _c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-select', {
    staticClass: "sucursal-select",
    attrs: {
      "items": _vm.items,
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "building-select",
    attrs: {
      "items": _vm.buildings,
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e2),
      callback: function($$v) {
        _vm.e2 = $$v
      },
      expression: "e2"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "rooms-select",
    attrs: {
      "items": _vm.rooms,
      "label": "Todas las habitaciones",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e3),
      callback: function($$v) {
        _vm.e3 = $$v
      },
      expression: "e3"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('v-select', {
    staticClass: "start-date-select",
    attrs: {
      "items": _vm.startDate,
      "label": "16 de octubre, 2016",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e4),
      callback: function($$v) {
        _vm.e4 = $$v
      },
      expression: "e4"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "finish-date-select",
    attrs: {
      "items": _vm.finishDate,
      "label": "10 de noviembre, 2016",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e5),
      callback: function($$v) {
        _vm.e5 = $$v
      },
      expression: "e5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "offset-md2": ""
    }
  }, [_c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Año")]), _vm._v(" "), _c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Mes")]), _vm._v(" "), _c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Semana")]), _vm._v(" "), _c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Día")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "divider-rows",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "divider1",
    attrs: {
      "md6": ""
    }
  }, [_c('v-layout', {
    staticClass: "room-filters",
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Habitaciones")]), _vm._v(" "), _c('v-select', {
    staticClass: "general-select",
    attrs: {
      "items": _vm.general,
      "label": "General",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e6),
      callback: function($$v) {
        _vm.e6 = $$v
      },
      expression: "e6"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "status-select",
    attrs: {
      "items": _vm.statusType,
      "label": "Tipos de estado",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e7),
      callback: function($$v) {
        _vm.e7 = $$v
      },
      expression: "e7"
    }
  }), _vm._v(" "), _c('button', [_vm._v("Editar")])], 1), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('v-layout', {
      key: state.id,
      staticClass: "text-xs-left",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md12": ""
      }
    }, [_c('div', {
      staticClass: "label-status"
    }, [_c('h5', [_vm._v(_vm._s(state.name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(state.rooms.length) + " habitaciones")])])])], 1)
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider2",
    attrs: {
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Estados")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "big",
    attrs: {
      "row": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "big-yellow"
  }, [_c('p', [_vm._v("15")])]), _vm._v(" "), _c('label', [_vm._v("En turno de baño o break")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-red"
  }, [_c('p', [_vm._v("03")])]), _vm._v(" "), _c('label', [_vm._v("Bajo rendimiento")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-green"
  }, [_c('p', [_vm._v("05")])]), _vm._v(" "), _c('label', [_vm._v("Alto rendimiento")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Mucamas")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "label-status mb-0"
  }, [_c('h5', [_vm._v("Nombre")]), _vm._v(" "), _c('h5', [_vm._v("Habitación")]), _vm._v(" "), _c('h5', [_vm._v("Calificación")])])]), _vm._v(" "), _vm._l((_vm.maidsNames), function(maid) {
    return _c('v-layout', {
      key: maid.id,
      staticClass: "report-maid",
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(maid.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('div', {
      class: ("score-ball-" + (maid.qualification))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(maid.room))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "alerts",
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Alertas")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "big b-alerts",
    attrs: {
      "row": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "big-skyblue"
  }, [_c('p', [_vm._v("16")])]), _vm._v(" "), _c('label', [_vm._v("Objetos perdidos")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-red"
  }, [_c('p', [_vm._v("13")])]), _vm._v(" "), _c('label', [_vm._v("Reportar problemas")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-yellow"
  }, [_c('p', [_vm._v("11")])]), _vm._v(" "), _c('label', [_vm._v("Mantenimiento")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Actividades - Real time")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "realtime-content"
  }, [_c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/59.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Maria Chiappe\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("cambió de estado")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("En curso")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("Almuerzo")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/32.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Almendra Gomez\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("terminó de limpiar la habitación")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("5202")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/men/78.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Giovanni Alvarado\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("cambió de estado")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-red"
  }, [_vm._v("Ocupado sucio")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-green"
  }, [_vm._v("Vacante limpio")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("habitación")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("5202")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/95.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Fernanda Rivera\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("reportó una perdida de la habitación")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("5412")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1)], 1)])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-849f8920","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/DashboardSales.vue
// module id = 754
// module chunks = 108